/**
 * AnalyticsContext — minimal context kept for backward compatibility.
 * The real analytics work is done by PostHog via AnalyticsSetup.
 */

import { useRouter } from 'next/router';
import * as React from 'react';

import { useCurrent } from '@/hooks/useCurrent';

type Analytics = {
  currentUserId: string | null;
  referral: string | string[] | null | undefined;
};

export const AnalyticsContext = React.createContext<Analytics>({
  currentUserId: null,
  referral: null,
});

export const useAnalytics = () => React.useContext(AnalyticsContext);

export const AnalyticsProvider: React.FC = ({ children }) => {
  const current = useCurrent();
  const router = useRouter();
  const referral = router.query.referral;

  return (
    <AnalyticsContext.Provider
      value={{
        referral,
        currentUserId: current.user?._id || null,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
